import React, { ReactElement, ReactNode } from "react";

export const PageRender = ({
  children,
}: {
  children: ReactNode;
}): ReactElement => {
  return (
    <div>
      <div>
        <div>{children}</div>
      </div>
    </div>
  );
};
